import { CompanyModel } from '@apto/models';
import './company-details-card.scss';
var CompanyDetailsCard = /** @class */ /*@__PURE__*/ (function () {
    function CompanyDetailsCard() {
    }
    return CompanyDetailsCard;
}());
export { CompanyDetailsCard };
